module.exports = __webpack_public_path__ + "img/yellow-booth-table-4.98075f51.png";